/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Devices_RefreshInputs */

const vi_irrigation_devices_refresh = /** @type {(inputs: Irrigation_Devices_RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Làm mới`)
};

/**

* @param {Irrigation_Devices_RefreshInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_devices_refresh = /** @type {((inputs?: Irrigation_Devices_RefreshInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Devices_RefreshInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_devices_refresh(inputs)
});